import { MessageCircle, KeyRound, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

const VALUE_ICONS = [MessageCircle, KeyRound, ShieldCheck];

export default function About() {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="hakkimizda" className="bg-paper py-20 md:py-28 border-t border-line scroll-mt-20" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-start">
          {/* Story */}
          <Reveal>
            <Overline>{a.overline}</Overline>
            <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.08]">
              {a.title}
            </h2>
            <p className="mt-6 text-stone text-base md:text-lg leading-relaxed">{a.p1}</p>
            <p className="mt-4 text-stone text-base md:text-lg leading-relaxed">{a.p2}</p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              {a.stats.map((s, i) => (
                <div key={i} className="rounded-2xl bg-mist border border-line p-4 text-center">
                  <div className="font-serif font-semibold text-2xl md:text-3xl text-brand tracking-tight leading-none">{s.big}</div>
                  <div className="mt-1.5 text-xs text-stone leading-snug">{s.small}</div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* Values */}
          <div className="space-y-4">
            {a.values.map((val, i) => {
              const Icon = VALUE_ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.08}>
                  <div className="flex gap-4 rounded-2xl bg-mist border border-line p-6">
                    <div className="h-12 w-12 shrink-0 rounded-xl bg-brand/10 text-brand flex items-center justify-center">
                      <Icon size={22} strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold tracking-tight">{val.t}</h3>
                      <p className="mt-1.5 text-sm text-stone leading-relaxed">{val.d}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
